module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Localização de Veículo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "patio"
    }
  }, [_vm._v("Patio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patio),
      expression: "patio"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Não selecione caso não queira uma filtragem por pátio",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.patio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectedPatio]
    }
  }, [_c('option', {
    staticStyle: {
      "font-weight": "bold"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione um patio")]), _vm._v(" "), _vm._l((_vm.patiosComputed), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.value
      }
    }, [_vm._v(_vm._s(cat.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.grvComputed,
      "placeholder": "Selecione uma grv",
      "filterable": false,
      "disabled": _vm.grvDisabled
    },
    on: {
      "search": _vm.getListaGrvs,
      "input": _vm.selectedGrv
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Atendente")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.recebedorPatio),
      expression: "data.recebedorPatio"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "recebedorPatio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.atendentes), function(atendente) {
    return _c('option', {
      key: atendente.id,
      domProps: {
        "value": atendente.id
      }
    }, [_vm._v(_vm._s(atendente.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Vaga")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.vaga),
      expression: "data.vaga"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "vaga",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.vaga)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "vaga", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h2', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Fotos do veículo\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Foto")]), _vm._v(" "), _c('th', [_vm._v("Formato foto")]), _vm._v(" "), _c('td', [_vm._v("Excluir")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.arquivos), function(arquivo, index) {
    return (arquivo.tipo === 1) ? _c('tr', [_c('td', {
      staticStyle: {
        "max-width": "10%"
      },
      attrs: {
        "scope": "row",
        "width": "10%"
      }
    }, [_vm._v(_vm._s(arquivo.id))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "position": "relative",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [(!arquivo.id) ? _c('div', {
      staticClass: "img-preview-placeholder"
    }, [_vm._v("\n                          Esta imagem é apenas um preview. "), _c('br'), _vm._v(" Salve a GRV para obter o link da imagem original\n                        ")]) : _vm._e(), _vm._v(" "), (arquivo.tipo !== 3) ? _c('img', {
      staticClass: "img-preview",
      attrs: {
        "src": arquivo.imageInfo && (arquivo.imageInfo.thumb ? arquivo.imageInfo.thumb : arquivo.imageInfo.full)['url'] || arquivo.arquivo || arquivo.thumb || '',
        "alt": "foto-veiculo",
        "loading": "lazy"
      }
    }) : _c('span', [_vm._v("Ver assinatura")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(arquivo.nomeOriginal))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (arquivo.apagar),
        expression: "arquivo.apagar"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'apagar-arquivo' + index,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(arquivo.apagar) ? _vm._i(arquivo.apagar, null) > -1 : (arquivo.apagar)
      },
      on: {
        "change": function($event) {
          var $$a = arquivo.apagar,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(arquivo, "apagar", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(arquivo, "apagar", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(arquivo, "apagar", $$c)
          }
        }
      }
    }), _c('i')])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.data.arquivos || _vm.data.arquivos.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Nenhum arquivo nesta GRV")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm m-t-n m-b"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileInptImg",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadFoto
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv btnPicDesktop",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleInputFile('fileInptImg')
      }
    }
  }, [_vm._v("\n                     Adicionar "), _c('i', {
    staticClass: "fa fa-picture-o"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("* Você pode selecionar mais de uma foto ao mesmo tempo para enviar")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', [_vm._v("Salvar")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-md m-l-xs btn-colsultaGrv pull-right"
  }, [_vm._v("Apagar\n              ")])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97da6f02","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/localizacao-veiculo/components/LocalizacaoVeiculo.vue
// module id = 2003
// module chunks = 18